import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import {
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Select,
  TextField,
} from "@mui/material";
import { DeleteForever, DeleteRounded, Search } from "@mui/icons-material";
import { chunk, escapeRegExp } from "lodash";
import { ReactComponent as FilterSvg } from "../../assets/filter.svg";

import { ReactComponent as DeleteSvg } from "../../assets/delete.svg";
import { ReactComponent as EditSvg } from "../../assets/RoundEdit.svg";
import { ReactComponent as ActiveSvg } from "../../assets/EllipseSvg.svg";
import { ReactComponent as InActiveSvg } from "../../assets/EllipseGraySvg.svg";

import { orderBy as odb } from "lodash";
import { getHighlightedText } from "../../utils/helpers";
import { Link, useNavigate } from "react-router-dom";
import UserCard from "./UserCard";
import DeletePopUp from "../../components/DeletePopup";
import i18n from "../../reducers/i18n";
import { deleteUser } from "../../actions/user";
import { useDispatch, useStore } from "react-redux";
import { canUserPerformAction } from "../../shared-functions/userrights";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


function getComparator(
  order,
  orderBy
) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const headCells = [
    {
      id: "s",
      numeric: false,
      disablePadding: false,
      // label: i18n().users.tableStatus,
    },
    {
      id: "Vorname",
      numeric: false,
      disablePadding: false,
      label: i18n().users.tableFirstName,
    },
    {
      id: "Nachname",
      numeric: false,
      disablePadding: false,
      label: i18n().users.tableLastName,
    },
    {
      id: "Benutzertyp",
      numeric: false,
      disablePadding: true,
      label: i18n().users.tableUserType,
    },
    {
      id: "EMailAdresse",
      numeric: false,
      disablePadding: false,
      label: i18n().users.tableEmail,
    },
    {
      id: "Actions",
      numeric: false,
      disablePadding: false,
      label: i18n().users.actions,
    },
  ];

  const { order, orderBy, onRequestSort, setActiveId } = props;
  const createSortHandler =
    (property) => (event) => {
      onRequestSort(event, property);
      setActiveId(property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            className="tableHead"
            width={index === 0 ? "5%" : index === 5 ? "5%" : "20%"}
            id={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              sx={{ display: "flex", flexDirection: "row" }}
              IconComponent={FilterSvg}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}



const UsersTable = ({
  searchText,
  data,
  handlePageChange,
  page,
  setPage,
  viewMode,
  refreshList,
  profiles,
  profile
}) => {


  const [userNodeId, setUserNodeId] = React.useState(null);

const {uiLanguage} = useStore().getState();


  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [selected, setSelected] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [activeId, setActiveId] = React.useState("Vorname");

  const [openDialogDelete, setopenDialogDelete] = React.useState(false);

  const navigate = useNavigate();

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
    setUserNodeId(null);
  };

  function stableSort(
    array,
    comparator
  ) {
    let sortedArray = [];

    switch (activeId) {
      case "Vorname":
        sortedArray = odb(array, ["Vorname"], [order]);
        break;
      case "Nachname":
        sortedArray = odb(array, ["Nachname"], [order]);
        break;
      case "Benutzertyp":
        sortedArray = odb(array, ["Benutzertyp"], [order]);
        break;
      case "EMailAdresse":
        sortedArray = odb(array, ["EMailAdresse"], [order]);
        break;
      default:
        sortedArray = odb(array, ["date"], [order]);
    }

    return sortedArray;
  }

  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  // const isSelected = (id: number) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  // const visibleRows = React.useMemo(
  //   () =>
  //     stableSort(rows, getComparator(order, orderBy)).slice(1
  //       page * rowsPerPage,
  //       page * rowsPerPage + rowsPerPage
  //     ),
  //   [order, orderBy, page, rowsPerPage]
  // );

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    (window).blurAll();
  };

  let paginationchunks = chunk(data, rowsPerPage);

  const dispatch = useDispatch();

  const handleDelete = async () => {
    dispatch(deleteUser({ nodeid: userNodeId }));
    setopenDialogDelete(false);
    refreshList();
  };

  return (
    <>
      {viewMode === "table" ? (
        <div>
          <Table
            aria-labelledby="tableTitle"
            size="medium"
            className="dashboardTable usersTable"
            sx={{ marginTop: "3%" }}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={data.length}
              lang={"de"}
              setActiveId={setActiveId}
              activeId={activeId}
            />

            <TableBody>
              {data.length > 0 ? (
                stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;


                    //console.log(row,"ROW")

                    return (
                      <TableRow
                        key={index}
                        style={{
                          height:
                            document.getElementById("rowDes-" + (index + 1))
                              ?.offsetHeight + "px",
                        }}
                      // hover
                      // onClick={(event) => handleClick(event, row.id)}
                      // role="checkbox"
                      // aria-checked={isItemSelected}
                      // tabIndex={-1}
                      // selected={isItemSelected}
                      // sx={{ cursor: 'pointer' }}
                      >
                        <TableCell
                          align="right"
                          className={
                            typeof row.s === "string" &&
                              row.s?.toLowerCase().includes("error")
                              ? "errorText"
                              : ""
                          }
                          sx={{ padding: "16px 16px 10px 16px" }}
                        >
                          <div className="rowTitle" style={{ textAlign: "center" }}>
                            {row.user.active ? <ActiveSvg /> : <InActiveSvg />}
                          </div>
                        </TableCell>

                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            position: "relative",
                            paddingTop: "10px",
                            paddingBottom: "5px"
                          }}
                          id={labelId}
                        >
                          <div className="rowTitle" style={{ color: row.user.active ? "#000000DE" : "#00000061", textAlign: "left" }}>
                            {getHighlightedText(row.user.givenname, searchText)}
                          </div>
                        </TableCell>
                        <TableCell
                          align="right"
                          className={
                            typeof row.s === "string" &&
                              row.s?.toLowerCase().includes("error")
                              ? "errorText"
                              : ""
                          }
                        >
                          <div className="rowTitle" style={{ color: row.user.active ? "#000000DE" : "#00000061", textAlign: "left" }}>
                            {getHighlightedText(row.user.surname, searchText)}
                          </div>
                        </TableCell>
                        <TableCell
                          align="right"
                          className={
                            typeof row.s === "string" &&
                              row.s?.toLowerCase().includes("error")
                              ? "errorText"
                              : ""
                          }
                        >
                          <div className="rowTitle" style={{ color: row.user.active ? "#000000DE" : "#00000061", textAlign: "left" }}>
                            {profiles.length ? profiles.filter((profile) => { return profile.id === row.userType })[0]?.name.de : ""}
                          </div>
                        </TableCell>

                        <TableCell align="right">
                          <div className="rowTitle" style={{ color: row.user.active ? "#000000DE" : "#00000061", textAlign: "left" }}>
                            {getHighlightedText(row.user.email, searchText)}
                          </div>
                        </TableCell>

                        <TableCell
                          align="right"
                          className={
                            index === data.length - 1 ? "lastTableRowCell" : ""
                          }
                        >
                          <div

                            style={{
                              display: row.isCurrentUser ? "none" : "flex",
                              alignItems: "center",
                              justifyContent: "right",
                            }}
                          >
                            {canUserPerformAction(
                              profile?.features?.user,
                              "delete"
                            ) && (<div
                              onClick={() => {
                                setopenDialogDelete(true);
                                setUserNodeId(row.user.nodeid);
                              }}
                              className="cp"
                              data-testid="btn_add_user_delete"
                            >
                              <DeleteSvg />
                            </div>)}
                            <div>
                              {canUserPerformAction(
                                profile?.features?.user,
                                "update"
                              ) && (<Link
                                className="cp"
                                state={{ pageType: "edit", user: { ...row.user, userType: row.userType, userid: row.userid } }}
                                to={"/fette/add-user"}
                                data-testid="lnk_add_user_edit"

                              >
                                <EditSvg height={30} width={20} />
                              </Link>)}

                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    {i18n()?.no_data}
                  </TableCell>
                </TableRow>
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={5} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      ) : (
        <Grid container spacing={2} sx={{ mt: 0 }}>
          {data.length ? (
            data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((user, index) => {
                return (
                  <>
                    <Grid item xs={6} md={6} key={index}>
                      <UserCard user={user} />
                    </Grid>
                  </>
                );
              })
          ) : (
            <div></div>
          )}
        </Grid>
      )}

      <div className="DashboardTablePagination">
        <div>
          {paginationchunks.length > 0 ? (
            <Pagination
              count={paginationchunks.length}
              shape="rounded"
              onChange={handlePageChange}
              hideNextButton={page === paginationchunks.length - 1}
              hidePrevButton={page === 0}
            />
          ) : (
            ""
          )}
        </div>
        <div>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              label={i18n()?.users?.rowsPerPage}
              className="perPageSelect"
            >
              <MenuItem value={5}>
                {5}
                {" "+ i18n(uiLanguage)?.users?.rowsPerPage}
              </MenuItem>
              <MenuItem value={5 * 2}>
                {5 * 2}
                {" "+i18n(uiLanguage)?.users?.rowsPerPage}
              </MenuItem>
              <MenuItem value={5 * 5}>
                {5 * 5}
                {" "+i18n(uiLanguage)?.users?.rowsPerPage}
              </MenuItem>
              <MenuItem value={5 * 10}>
                {5 * 10}
                {" "+i18n(uiLanguage)?.users?.rowsPerPage}
              </MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
        topic="Users"
      ></DeletePopUp>
    </>
  );
};
export default UsersTable;
